const campaignType = {
    PAID: 'PAID',
    NATIVE: 'NATIVE',
    EXCHANGE: 'EXCHANGE',
    RTB_OPEN_EXCHANGE: 'RTB_OPEN_EXCHANGE',
    PMP_DEAL: 'PMP_DEAL',
};

export default campaignType;
